import type { GPV6TemplateType, GPV7TemplateType } from '~/types/template';
import { TemplateType } from '~/types/template';

export function convertTemplateTypeToGPV7(type: TemplateType): GPV7TemplateType | undefined {
  switch (type) {
    case TemplateType.COLLECTION:
      return 'GP_COLLECTION';
    case TemplateType.PRODUCT:
      return 'GP_PRODUCT';
    case TemplateType.HOME:
      return 'GP_INDEX';
    case TemplateType.BLOG:
    case TemplateType.ARTICLE:
      return 'GP_ARTICLE';
    case TemplateType.PAGE:
      return 'GP_STATIC';
    default:
      return 'GP_STATIC';
  }
}

export function convertTemplateTypeToGPV6(type: TemplateType): GPV6TemplateType | undefined {
  switch (type) {
    case TemplateType.COLLECTION:
      return 'template-collection';
    case TemplateType.PRODUCT:
      return 'template-product';
    case TemplateType.HOME:
      return 'template-index';
    case TemplateType.BLOG:
    case TemplateType.ARTICLE:
      return 'template-article';
    case TemplateType.PAGE:
      return 'template-page';
    default:
      return 'template-page';
  }
}

export function convertGPV7ToTemplateType(type: GPV7TemplateType): TemplateType | undefined {
  switch (type) {
    case 'ARTICLE':
    case 'GP_ARTICLE':
      return TemplateType.ARTICLE;
    case 'BLOG':
    case 'GP_BLOG':
      return TemplateType.BLOG;
    case 'COLLECTION':
    case 'GP_COLLECTION':
      return TemplateType.COLLECTION;
    case 'GP_FUNNEL_PAGE':
    case 'GP_STATIC':
    case 'POST_PURCHASE':
    case 'STATIC':
      return TemplateType.PAGE;
    case 'GP_INDEX':
      return TemplateType.HOME;
    case 'GP_PRODUCT':
    case 'PRODUCT':
      return TemplateType.PRODUCT;
    default:
      return undefined;
  }
}

export function convertGPV6ToTemplateType(type: GPV6TemplateType): TemplateType | undefined {
  switch (type) {
    case 'template-article':
      return TemplateType.ARTICLE;
    case 'template-collection':
      return TemplateType.COLLECTION;
    case 'template-page':
      return TemplateType.PAGE;
    case 'template-index':
      return TemplateType.HOME;
    case 'template-product':
      return TemplateType.PRODUCT;
    default:
      return undefined;
  }
}
